<div class="section-heading action-heading">

  <div>

    <span class="section-kicker">
      Community page
    </span>

    <h2>
      Community posts
    </h2>

    <p>
      Publish posts immediately or schedule them
      automatically using the selected post date.
    </p>

  </div>

  <button
    type="button"
    class="primary-btn"
    (click)="openPostEditor()"
  >
    ＋ New post
  </button>

</div>


<!-- =========================================================
     SCHEDULED POSTS
     ========================================================= -->

<section class="post-group">

  <div class="post-group-heading">

    <div>

      <span class="post-status scheduled-status">
        Scheduled
      </span>

      <h3>
        Upcoming posts
      </h3>

      <p>
        These posts will go live automatically
        on their selected date.
      </p>

    </div>

    <span class="post-count">
      {{ scheduledPosts.length }}
    </span>

  </div>


  <div
    *ngIf="scheduledPosts.length > 0"
    class="content-card-grid"
  >

    <article
      class="content-card scheduled-card"
      *ngFor="
        let post of scheduledPosts;
        trackBy: trackById
      "
    >

      <div
        class="content-image post-image"
        [class.placeholder]="!post.imageUrl"
      >

        <img
          *ngIf="post.imageUrl"
          [src]="post.imageUrl"
          [alt]="post.title"
        />

        <span *ngIf="!post.imageUrl">
          Community
        </span>

        <span class="card-status-badge scheduled">
          Scheduled
        </span>

      </div>


      <div class="content-card-body">

        <time [attr.datetime]="post.date">
          Goes live
          {{ post.date | date: 'MMMM d, y' }}
        </time>

        <h3>
          {{ post.title }}
        </h3>

        <p>
          {{ post.description }}
        </p>

        <a
          *ngIf="post.link"
          [href]="post.link"
          target="_blank"
          rel="noopener"
        >
          Attached link ↗
        </a>

      </div>


      <div class="card-actions">

        <button
          type="button"
          class="edit-btn"
          (click)="openPostEditor(post)"
        >
          Edit
        </button>

        <button
          type="button"
          class="delete-btn"
          (click)="
            requestDelete(
              'post',
              post.id,
              post.title
            )
          "
        >
          Delete
        </button>

      </div>

    </article>

  </div>


  <div
    *ngIf="scheduledPosts.length === 0"
    class="empty-post-state"
  >
    No community posts are currently scheduled.
  </div>

</section>


<!-- =========================================================
     LIVE POSTS
     ========================================================= -->

<section class="post-group">

  <div class="post-group-heading">

    <div>

      <span class="post-status live-status">
        Live
      </span>

      <h3>
        Published posts
      </h3>

      <p>
        These posts are currently visible
        on the public community page.
      </p>

    </div>

    <span class="post-count">
      {{ livePosts.length }}
    </span>

  </div>


  <div
    *ngIf="livePosts.length > 0"
    class="content-card-grid"
  >

    <article
      class="content-card"
      *ngFor="
        let post of livePosts;
        trackBy: trackById
      "
    >

      <div
        class="content-image post-image"
        [class.placeholder]="!post.imageUrl"
      >

        <img
          *ngIf="post.imageUrl"
          [src]="post.imageUrl"
          [alt]="post.title"
        />

        <span *ngIf="!post.imageUrl">
          Community
        </span>

        <span class="card-status-badge live">
          Live
        </span>

      </div>


      <div class="content-card-body">

        <time [attr.datetime]="post.date">
          {{ post.date | date: 'MMMM d, y' }}
        </time>

        <h3>
          {{ post.title }}
        </h3>

        <p>
          {{ post.description }}
        </p>

        <a
          *ngIf="post.link"
          [href]="post.link"
          target="_blank"
          rel="noopener"
        >
          Attached link ↗
        </a>

      </div>


      <div class="card-actions">

        <button
          type="button"
          class="edit-btn"
          (click)="openPostEditor(post)"
        >
          Edit
        </button>

        <button
          type="button"
          class="delete-btn"
          (click)="
            requestDelete(
              'post',
              post.id,
              post.title
            )
          "
        >
          Delete
        </button>

      </div>

    </article>

  </div>


  <div
    *ngIf="livePosts.length === 0"
    class="empty-post-state"
  >
    No community posts are currently live.
  </div>

</section>


<!-- =========================================================
     POST EDITOR
     ========================================================= -->

<div
  *ngIf="postEditorOpen"
  class="modal-backdrop"
>

  <section
    class="editor-modal"
    role="dialog"
    aria-modal="true"
    (click)="$event.stopPropagation()"
  >

    <header class="modal-header">

      <div>

        <span class="section-kicker">
          Community page
        </span>

        <h2>
          {{
            postDraft.id
              ? 'Edit post'
              : 'New community post'
          }}
        </h2>

      </div>

      <button
        type="button"
        class="close-btn"
        aria-label="Close"
        (click)="closePostEditor()"
      >
        ×
      </button>

    </header>


    <form (ngSubmit)="savePost()">

      <div class="form-grid">

        <div class="form-field">

          <label for="post-title">
            Post title
          </label>

          <input
            id="post-title"
            name="title"
            [(ngModel)]="postDraft.title"
            required
          />

        </div>


        <div class="form-field">

          <label for="post-date">
            Post date
          </label>

          <input
            id="post-date"
            type="date"
            name="date"
            [(ngModel)]="postDraft.date"
            required
          />

        </div>


        <div class="form-field full-width">

          <label for="post-description">
            Description
          </label>

          <textarea
            id="post-description"
            name="description"
            rows="5"
            [(ngModel)]="postDraft.description"
          ></textarea>

        </div>


        <div class="form-field full-width">

          <label for="post-link">
            Optional external link
          </label>

          <input
            id="post-link"
            type="url"
            name="link"
            [(ngModel)]="postDraft.link"
            placeholder="https://..."
          />

        </div>

      </div>


      <!-- =====================================================
           IMAGE UPLOAD
           ===================================================== -->

      <div class="upload-field">

        <div
          class="upload-preview post-image"
          [class.placeholder]="!postDraft.imageUrl"
        >

          <img
            *ngIf="postDraft.imageUrl"
            [src]="postDraft.imageUrl"
            alt="Post preview"
          />

          <span *ngIf="!postDraft.imageUrl">
            Community
          </span>

        </div>


        <div>

          <strong>
            Post image
          </strong>

          <p>
            Choose a landscape JPG, PNG or WebP image.
          </p>

          <div class="upload-actions">

            <label class="secondary-btn file-btn">

              Choose image

              <input
                type="file"
                accept="image/*"
                (change)="onImageSelected($event)"
              />

            </label>

            <button
              *ngIf="postDraft.imageUrl"
              type="button"
              class="text-btn"
              (click)="removeDraftImage()"
            >
              Remove image
            </button>

          </div>

        </div>

      </div>


      <!-- =====================================================
           FORM ACTIONS
           ===================================================== -->

      <div class="form-actions modal-actions">

        <button
          type="button"
          class="text-btn"
          (click)="closePostEditor()"
        >
          Cancel
        </button>

        <button
          type="submit"
          class="primary-btn"
        >
          Save post
        </button>

      </div>

    </form>

  </section>

</div>


<!-- =========================================================
     DELETE CONFIRMATION
     ========================================================= -->

<div
  *ngIf="deleteRequest"
  class="modal-backdrop confirm-backdrop"
  (click)="cancelDelete()"
>

  <section
    class="confirm-modal"
    role="alertdialog"
    aria-modal="true"
    (click)="$event.stopPropagation()"
  >

    <div class="confirm-icon">
      !
    </div>

    <h2>
      Delete “{{ deleteRequest.label }}”?
    </h2>

    <p>
      This post will be permanently removed.
      This action cannot be undone.
    </p>

    <div class="form-actions">

      <button
        type="button"
        class="secondary-btn"
        (click)="cancelDelete()"
      >
        Cancel
      </button>

      <button
        type="button"
        class="danger-btn"
        (click)="confirmDelete()"
      >
        Delete permanently
      </button>

    </div>

  </section>

</div>